import React from 'react';
import { useSelector } from 'react-redux';
import * as S from './styles';

export const PopUpLista = () => {
  const systems = useSelector(state => state.sefaz?.allSystems);

  const getImagem = imagem => {
    return `data:image/png;base64,${imagem}`;
  };

  const renderItem = (item, index) => {
    return (
      <S.ContainerSystemIcon key={`${item?.id} - ${index} - ${item?.sigla}`} onClick={() => window.open(item?.url)}>
        <S.SystemImagem src={getImagem(item?.imagem)} alt={item.sigla} />
        {item?.sigla}
      </S.ContainerSystemIcon>
    );
  };

  return (
    <S.ContainerSystem>{systems?.length && systems.map((item, index) => renderItem(item, index))}</S.ContainerSystem>
  );
};
